<template>
    <div class="bg-surface-secondary w-100">
        <header class="bg-surface-primary border-bottom">
            <div class="container-fluid py-4">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="d-flex align-items-center gap-4">
                            <div>
                                <button type="button" class="btn-close text-xs"
                                    @click="$router.push({ name: 'Reports' })"></button>
                            </div>
                            <div class="vr opacity-20 my-1"></div>
                            <h1 class="h4 ls-tight">Reporte por peso</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid vstack gap-5">
                <div class="card">
                    <div class="card-body">
                        <form class="row" @submit.prevent="FILTER()">
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2">
                                <small class="input-title">Cliente</small>
                                <search-user v-model="filter.user" @set_value="e => filter.user_id = e" clearable />
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2">
                                <small class="input-title">Estado</small>
                                <v-select v-model="filter.state_id" multiple :items="states" item-value="id"
                                    item-text="name" hide-details clearable class="form-control form-control-sm">
                                </v-select>
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2">
                                <small class="input-title">Estado de pago</small>
                                <v-select v-model="filter.payment_state_id" multiple :items="payment_states" item-value="id"
                                    item-text="name" hide-details clearable class="form-control form-control-sm">
                                </v-select>
                            </div>
                            <div class="col-12"></div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2" v-if="filter.date_range == 'date_range'">
                                <small class="input-title">Peso desde</small>
                                <input type="number" min="0" :max="filter.end_weight" v-model="filter.start_weight" class="form-control form-control-sm">
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2" v-if="filter.date_range == 'date_range'">
                                <small class="input-title">Peso hasta</small>
                                <input type="number" :min="filter.start_weight" v-model="filter.end_weight" class="form-control form-control-sm">
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2" v-if="filter.date_range == 'date_range'">
                                <small class="input-title">Fecha desde</small>
                                <v-menu v-model="menu_start" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="filter.start_date" v-bind="attrs" v-on="on" hide-details
                                            dense readonly clearable class="form-control form-control-sm"
                                            @click:clear="filter.start_date = ''">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="filter.start_date" no-title scrollable
                                        :max="filter.end_date"
                                        @input="menu_start = false">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2" v-if="filter.date_range == 'date_range'">
                                <small class="input-title">Fecha hasta</small>
                                <v-menu v-model="menu_end" :close-on-content-click="false" transition="scale-transition"
                                    offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="filter.end_date" v-bind="attrs" v-on="on" hide-details
                                            dense readonly clearable class="form-control form-control-sm"
                                            @click:clear="filter.end_date = ''">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="filter.end_date" no-title scrollable
                                        :min="filter.start_date"
                                        :max="now"
                                        @input="menu_end = false">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                            <div class="col-12 mt-3"></div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2">
                                <div>
                                    <button type="submit" :disabled="loading == 'filter'"class="btn btn-h px-3 btn-primary w-100">
                                        <div class="spinner-border spinner-border-sm" role="status"
                                            v-if="loading == 'filter'">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <span v-else>Filtrar</span>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2">
                                <div>
                                    <button type="button" class="btn btn-h px-3 btn-danger w-100" @click="CLEAR()">
                                        <div class="spinner-border spinner-border-sm" role="status"
                                            v-if="loading == 'clear'">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <span v-else>Limpiar</span>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-3 pl-0 pr-0 pr-md-2 mb-2">
                                <v-select v-model="filter.date_range" :items="date_ranges" item-value="id"
                                    item-text="name" hide-details class="form-control form-control-sm">
                                </v-select>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header bg-white d-flex justify-content-between align-items-center">
                        <h5 class="me-auto">Listado</h5>
                        <a v-if="hash" :href="endpoint.slice(0, -6) + 'v1/reports/my/' + hash" target="_blank" class="btn btn-m px-3 btn-neutral"><i class="fas fa-print"></i></a>
                    </div>
                    <div class="card-body p-0">
                        <div style="height: 100vh;" class="p-4" v-if="href">
                            <iframe :src="href" frameborder="0" width="100%" height="100%" id="report-iframe"></iframe>
                        </div>
                        <p class="text-sm text-muted text-center mb-0 py-3" v-else>No hay resultados.</p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        var now = new Date()
        return {
            menu_start: false,
            menu_end: false,
            filter: {
                start_weight: 0,
                end_weight: 100,
                start_date: moment(now).subtract(1, 'month').format('YYYY-MM-DD'),
                end_date: moment(now).format('YYYY-MM-DD'),
                date_range: 'date_range',
            },
            now: moment().toISOString(),
            date_ranges: [
                { id: 'date_range', name: 'Rango de Fecha' },
                { id: 'current_month', name: 'Mes Actual' },
                { id: 'previous_month', name: 'Mes Anterior' },
                { id: '7', name: 'Últimos 7 días' },
                { id: '15', name: 'Últimos 15 días' },
                { id: '30', name: 'Últimos 30 días' },
                { id: '60', name: 'Últimos 60 días' },
                { id: '90', name: 'Últimos 90 días' },
            ],
            loading: '',
            href: '',
            hash: '',
            endpoint: process.env.API,
            states: [],
            payment_states: [],
            cancelToken: null,
            batch: null
        }
    },
    mounted() {
        let vue = this
        vue.STATES()
        vue.PAYMENT_STATES()
        Echo.channel('notification.' + this.user.id)
            .listen('FinishEvent', (e) => {
                if(e.many == true){
                    vue.$swal({ toast: true, icon: 'error', title: e.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.$store.dispatch('REMOVE_TAGS', vue.tags.findIndex((a) => a.id == e.id))
                }else{
                    vue.$store.dispatch('ADD_TAGS', e)
                    if(vue.batch){
                        if(e.id == vue.batch.id){
                            vue.batch = e
                            vue.loading = ''
                            vue.hash = e.hash
                            if(vue.batch.error == true){
                                vue.$swal({ toast: true, icon: 'error', title: e.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            }else{
                                if(vue.$route.name == 'ReportPackageByWeight' && e.type == 'ReportPackageByWeight'){
                                    vue.href = e.href
                                    vue.$store.dispatch('REMOVE_TAGS', vue.tags.findIndex((a) => a.id == vue.batch.id))
                                }
                            }
                        }
                    }
                }
            })
    },
    computed: {
        ...mapGetters([
            'tags',
            'user'
        ])
    },
    methods: {
        STATES: function () {
            let vue = this
            axios({ url: '/all/states', method: 'GET' })
                .then((resp) => {
                    vue.states = resp.data
                })
        },
        PAYMENT_STATES: function () {
            let vue = this
            axios({ url: '/all/payment/states', method: 'GET' })
                .then((resp) => {
                    vue.payment_states = resp.data
                })
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.href = ''
            vue.hash = ''
            vue.loading = ''
            var now = new Date()
            vue.filter = {
                start_date: moment(now).subtract(1, 'month').format('YYYY-MM-DD'),
                end_date: moment(now).format('YYYY-MM-DD'),
                date_range: 'date_range',
            }
        },
        FILTER: function () {
            let vue = this
            vue.loading = 'filter'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.href = ''
            vue.hash = ''
            vue.DATA()
        },
        DATA: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            let query = {}
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/reports/package-by-weight',
                method: 'GET',
                params: query,
                cancelToken: source.token
            })
                .then((response) => {
                    vue.batch = response.data
                    setTimeout(function(){
                        if(vue.href){
                            vue.loading = ''
                            vue.$swal({ toast: true, icon: 'success', title: 'Reporte generado con éxito.', position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }else{
                            vue.loading = ''
                            vue.$store.dispatch('ADD_TAGS', vue.batch)
                            if(!vue.batch.error){
                                vue.$swal({ toast: true, icon: 'success', title: 'El reporte tardo mas de lo esperado', position: 'top-end', showConfirmButton: false, timer: 3000 })
                            }
                        }
                    }, 5000);
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        }
    },
}
</script>
<style>
#virtual-scroll-table {
    max-height: 300px;
    overflow: auto;
}
</style>